import {SelectElement} from "../../components/common/select/select.model";
import {ValueAndLabelModel} from "../../modules/common/model/valueAndLabel.model";
import {MovementType} from "../../modules/accounting/movement/api/entity/accountingMovement.model";

const allPaymentTypes: ValueAndLabelModel[] = [
    new ValueAndLabelModel('CARD', 'Carte bancaire'),
    new ValueAndLabelModel('CHECK', 'Chèque'),
    new ValueAndLabelModel('CASH', 'En espèce'),
    new ValueAndLabelModel('BANK', 'Virement bancaire')];

export class PaymentTypesUtils {


    public static getPaymentTypesForMovement(movementType: MovementType, sourceAccountTypeValue: string, targetAccountTypeValue: string): ValueAndLabelModel[] {
        console.log(['getPaymentTypesForMovement', movementType, sourceAccountTypeValue, targetAccountTypeValue]);


        let paymentTypes: ValueAndLabelModel[] = [];
        if(movementType === MovementType.EXPENDITURE) {
            paymentTypes = this.filterPaymentTypeForExpenditure(allPaymentTypes, sourceAccountTypeValue);
        }
        if(movementType === MovementType.REVENUE) {
            paymentTypes = this.filterPaymentTypeForRevenue(allPaymentTypes, targetAccountTypeValue);
        }
        if(movementType === MovementType.TRANSFER) {
            paymentTypes = this.filterPaymentTypeForTransfer(allPaymentTypes, sourceAccountTypeValue, targetAccountTypeValue);
        }
        return paymentTypes;
    }


    private static filterPaymentTypeForRevenue(allPaymentTypes: SelectElement[], targetAccountType: string): ValueAndLabelModel[] {
        return allPaymentTypes.filter(element => {
            if (targetAccountType === 'CHECKOUT') {
                return element.value === 'CHECK' || element.value === 'CASH';
            }
            if (targetAccountType === 'ONLINE') {
                return element.value === 'CARD' || element.value === 'BANK';
            }
            if (targetAccountType === 'BANK_ACCOUNT') {
                return element.value === 'CARD' || element.value === 'BANK';
            }


            return true;
        });
    }

    private static filterPaymentTypeForExpenditure(allPaymentTypes: SelectElement[], sourceAccountType: string): ValueAndLabelModel[] {
        const matchingPaymentTypes = allPaymentTypes.filter(element => {
            if (sourceAccountType === 'CHECKOUT') {
                return element.value === 'CASH';
            }
            if (sourceAccountType === 'BANK_ACCOUNT') {
                return element.value === 'CARD' || element.value === 'BANK';
            }

            if (sourceAccountType === 'ONLINE') {
                return element.value === 'CARD' || element.value === 'BANK';
            }

            return true;
        });
        console.log([sourceAccountType, allPaymentTypes, matchingPaymentTypes]);
        return matchingPaymentTypes;
    }

    private static filterPaymentTypeForTransfer(allPaymentTypes: SelectElement[], sourceAccountType: string, targetAccountType: string): ValueAndLabelModel[] {
        return allPaymentTypes.filter(element => {
            if (sourceAccountType === 'CHECKOUT') {
                return element.value === 'CHECK' || element.value === 'CASH';
            }
            if (sourceAccountType === 'BANK_ACCOUNT') {
                if (targetAccountType === 'BANK_ACCOUNT') {
                    return element.value === 'BANK';
                }
                if (targetAccountType === 'CHECKOUT') {
                    return element.value === 'CASH';
                }
            }
            return false;
        });
    }
}